module.exports = __webpack_public_path__ + "static/media/ArrowUp.35bf9631.svg";